module.exports = __webpack_public_path__ + "static/media/firmaYamila.74114405.png";